import { api } from "./backend";

export const create = (data) => api.post("/front/signup", data);
